export default "__VITE_ASSET__509967ce__"